export default "__VITE_ASSET__DgZfeKB0__"